import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../../../services/auth/auth.service";

export const beforeLoginGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const loggedIn = auth.isLoggedIn();
  // console.log('beforeLoginGuard - isLoggedIn:', loggedIn, 'route:', state.url);

  if (loggedIn) {
    // Redirect to home dashboard if user is already logged in
    return router.navigateByUrl("/home/dashboard", { replaceUrl: true });
  } else {
    return true;
  }
};
